import { Routes, Route, Navigate } from 'react-router-dom';
import { SingleCard } from './layouts';
import { LoginForm } from 'components';

export const UnauthenticatedContent = () => (
  <Routes>
    <Route path="/login" element={<SingleCard title="Вхід" withLogo={true} width={'400px'}><LoginForm /></SingleCard>}/>
    <Route path="/create-account" element={<SingleCard title="Sign Up"/>}/>
    <Route path="*" element={<Navigate to='/login' replace={true}/>} />
  </Routes>
);
